module.exports = __webpack_public_path__ + "img/player_damage_003.1496ffba.png";